import store from '../../src/store'; 

export const getPermissionForComponent = (componentName, userGroup) => {
  const groupPermissions = store.getState().AppState.permissionGroup;


  // const user = store.getState().AppState.user;

  // // Get the permissions for the specific user group
  // const groupPermissions = permissionGroups[userGroup];

  if (groupPermissions && groupPermissions[componentName]) {

    const { read, write } = groupPermissions[componentName];


    // if ((read && write) || user?.epikEngineering) {
    if (read && write) {
      return 'both';
    } else if (write) {
      return 'write';
    } else if (read) {
      return 'read';
    }
  }

  return false; // No access
};
